<template>
  <div>
    <v-row>
      <v-col>
        <div class="d-flex justify-center align-center">
          <div class="d-flex flex-column align-center">
            <v-img
              max-height="272"
              max-width="329"
              src="@/assets/alertaDISAtivo512h.png"
            ></v-img>
            <div
              v-if="$vuetify.breakpoint.lgAndUp"
              class="d-flex"
              style="padding-top: 60px"
            >
              <img
                class="mr-4"
                width="180"
                src="@/assets/logo-branco-laranja.svg"
              />
              <v-img
                max-width="132"
                max-height="48"
                src="@/assets/logo-copel.png"
              ></v-img>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "logo",
};
</script>
